import { API_URL } from 'shared/api/Constants';
import { apiInterceptor } from './axios';
import axios from 'axios';
import { IDeleteGuardian } from 'store/interfaces/IUserDetails';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleMessage } from 'shared/api/ErrorMessages';

interface Error {
  data: any;
}

export const updateProviderDetailsAPI = (patientId: number, type: string, data: any) => {
  return apiInterceptor.put(`${API_URL.PROVIDER_DETAILS}${patientId}?type=${type}`, data).then((response: any) => {
    return response;
  });
};

export const getProviderDetailsAPI = (patientId: any, type: string) => {
  return apiInterceptor.get(`${API_URL.PROVIDER_DETAILS}${patientId}?type=${type}`).then((response: any) => {
    return response;
  });
};

export const getPatientDetailsAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.GET_PATIENT}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const addPatientDetailsAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.GET_PATIENT}`, data).then((response: any) => {
    return response;
  });
};

export const udpatePatientDetailsAPI = (data: any) => {
  return apiInterceptor.put(`${API_URL.GET_PATIENT}`, data).then((response: any) => {
    return response;
  });
};

export const getGuardianDetailsAPI = (params: any) => {
  return apiInterceptor.get(`${API_URL.GUARDIAN_DETAILS}${params.userId}`).then((response: any) => {
    return response;
  });
};

export const updateGuradianDetailsAPI = (param: any, data: any) => {
  return apiInterceptor.put(`${API_URL.GUARDIAN_DETAILS}${param.userId}`, data).then((response: any) => {
    return response;
  });
};

export const deleteGuardianDetailsAPI = (params: IDeleteGuardian) => {
  return apiInterceptor
    .delete(`${API_URL.GUARDIAN_DETAILS}${params.patientId}/${params.guardianId}`)
    .then((response) => {
      return response;
    });
};

export const getPharmacyDetailsAPI = (patientId: any) => {
  return apiInterceptor.get(`${API_URL.PHARMACY_DETAILS}${patientId}`).then((response: any) => {
    return response;
  });
};

export const savePharmacyDetailsAPI = (patientId: number, data: any) => {
  return apiInterceptor.put(`${API_URL.PHARMACY_DETAILS}${patientId}`, data).then((response: any) => {
    return response;
  });
};

export const getInsuranceDetailsAPI = (id: number) => {
  return apiInterceptor.get(`${API_URL.INSURANCE_DETAILS}${id}`).then((response: any) => {
    return response;
  });
};

export const deleteSecondaryInsuranceAPI = (paymentInfoId: number, patientId: number) => {
  return apiInterceptor
    .delete(`${API_URL.INSURANCE_DETAILS}${paymentInfoId}/patients/${patientId}/secondary-insurance`)
    .then((response: any) => {
      return response;
    });
};

export const saveInsuranceDetailsAPI = (id: any, data: any) => {
  return apiInterceptor.put(`${API_URL.INSURANCE_DETAILS}${id}`, data).then((response: any) => {
    return response;
  });
};

export const uploadCardImageAPI = (onProgressUpdate: (progress: number) => void, data: any, fileData: any) => {
  const actualtoken = sessionStorage.getItem('access-token');
  const token = actualtoken?.slice(1, -1);
  const header = {
    Authorization: `Bearer ${token}`,
    Connection: 'keep-alive',
    'Accept-Encoding': 'gzip, deflate, br',
    Accept: '*/*',
  };

  return axios
    .post(`${API_URL.FILE_UPLOAD}${data.patientId}/${data.imageSide}/${data.insuranceType}`, fileData, {
      headers: header,
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        if (total !== undefined && typeof onProgressUpdate === 'function') {
          const percent = Math.round((loaded * 100.0) / total);
          onProgressUpdate(percent);
        }
      },
    })
    .then((response: any) => {
      return response;
    });
};

export const downloadCardImageAPI = (data: any) => {
  const actualtoken = sessionStorage.getItem('access-token');
  const token = actualtoken?.slice(1, -1);
  const header = {
    Authorization: `Bearer ${token}`,
    Accept: '*/*',
  };
  return axios
    .get(`${API_URL.FILE_UPLOAD}${data.patientId}/${data.imageSide}/${data.insuranceType}`, { headers: header })
    .then((response: any) => {
      return response;
    });
};

export const getProfileStatusAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.PROFILE_STATUS}/${patientId}`).then((response: any) => {
    return response;
  });
};

// Aggregated profile/MFSH/M-Wise(MCAT)/intake-paperwork completion + migrationStatus in one call
// - self-scheduling passes these straight through as query params on its own free-slot fetches
// (getSelfSchedulingProvidersAPI/getSelfSchedulingProviderAvailabilityAPI) so ehr-sync-service can
// apply the NEW-patient onboarding blackout without re-fetching this itself.
export const getSelfSchedulingEligibilityAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.PROFILE_STATUS}/${patientId}/self-scheduling-eligibility`)
    .then((response: any) => {
      return response;
    });
};

export const getPendingOnboardingStepAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.GET_PATIENT}/${patientId}/pending-onboarding-step`)
    .then((response: any) => {
      return response;
    });
};

export const getPatientDetailsFromAdminAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.PATIENT_DETAILS_FOR_ADMIN}/${patientId}`).then((response: any) => {
    return response;
  });
};

/**
 * MM-1106: Permanently deletes a patient account (admin only). The server rejects
 * the request if the patient has any appointment history.
 */
export const hardDeletePatientAPI = (patientId: number) => {
  return apiInterceptor.delete(`${API_URL.HARD_DELETE_PATIENT}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const getPatientContactAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.PATIENT_CONTACT}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const updatePatientContactAPI = (source: string, patientId: number,contactData: any) => {
  return apiInterceptor.put(`${API_URL.PATIENT_CONTACT}/${source}/${patientId}`, { ...contactData }).then((response: any) => {
    return response;
  });
};

export const getCurrentTreatmentPlanAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.DR_CHRONO_CHART_DETAILS}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const uploadProfileImageAPI = (fileData: any, patientId: number) => {
  const actualtoken = sessionStorage.getItem('access-token');
  const token = actualtoken?.slice(1, -1);
  const header = {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
    // Connection: 'keep-alive',
    // 'Accept-Encoding': 'gzip, deflate, br',
    Accept: '*/*',
  };
  return axios
    .put(`${API_URL.PROFILE_IMAGE}/${patientId}`, fileData, {
      headers: header,
    })
    .then((response: any) => {
      return response;
    });
};

export const getProfileImageAPI = (patientId: any) => {
  const actualtoken = sessionStorage.getItem('access-token');
  const token = actualtoken?.slice(1, -1);
  const header = {
    Authorization: `Bearer ${token}`,
    Accept: '*/*',
  };
  return axios.get(`${API_URL.PROFILE_IMAGE}/${patientId}`, { headers: header }).then((response: any) => {
    return response;
  });
};

export const uploadGuradianImageAPI = (fileData: any, patientId: number, guardianId: number) => {
  const actualtoken = sessionStorage.getItem('access-token');
  const token = actualtoken?.slice(1, -1);
  const header = {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
    // Connection: 'keep-alive',
    // 'Accept-Encoding': 'gzip, deflate, br',
    Accept: '*/*',
  };
  return axios
    .put(`${API_URL.GUARDIAN_IMAGE}/${patientId}/${guardianId}`, fileData, {
      headers: header,
    })
    .then((response: any) => {
      return response;
    });
};

export const getCityStateAPI = (zipcode: number) => {
  return apiInterceptor.get(`${API_URL.GET_CITY_STATE}/${zipcode}`).then((response: any) => {
    return response;
  });
};

export const updatePinAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.UPDATE_PIN}`, data).then((response: any) => {
    return response;
  });
};

export const checkPinAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.CHECK_PIN}`, data).then((response: any) => {
    return response;
  });
};

export const getSiblingAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_SIBLING}`).then((response: any) => {
    return response;
  });
};

export const getSiblingForAdminAPI = (userId: number) => {
  return apiInterceptor.get(`${API_URL.GET_SIBLING_ADMIN}/${userId}`).then((response: any) => {
    return response;
  });
};
export const deleteSiblingAPI = (id: any) => {
  return apiInterceptor.get(`${API_URL.GET_SIBLING}/${id}`).then((response: any) => {
    return response;
  });
};

export const getSiblingAutoCompleteAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_SIBLING_AUTOCOMPLETE}`).then((response: any) => {
    return response;
  });
};



export const updatePasswordAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.UPDATE_PASSWORD}`, data).then((response: any) => {
    return response;
  });
};

export const uploadMdacProviderData = async (fileData: File) => {
  const token = sessionStorage.getItem('access-token')?.slice(1, -1);
  const formData = new FormData();
  formData.append('file', fileData);

  try {
    const response = await axios.post(`${API_URL.PROVIDER_UPLOAD}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
      },
      responseType: 'blob', // to handle file blob response
    });

    // Try reading it as text
    const text = await response.data.text?.().catch(() => null);

    if (text === 'Office details imported successfully.') {
      return { success: true, message: text };
    }

    // If not string, it's a Blob (XLSX with errors)
    if (response.data instanceof Blob) {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      return { success: false, hasFile: true, file: blob };
    }

    return {
      success: false,
      message: 'Unexpected response from server.',
    };
  } catch (error: any) {
    let errorData = await error.response?.data?.text?.().catch(() => null);
    if (errorData && typeof errorData === 'string') {
      errorData = JSON.parse(errorData);
      return { success: false, message: errorData.errorMsg };
    }
    // Handle Axios error
    if (axios.isAxiosError(error)) {
      const errData = error.response?.data;

      if (Array.isArray(errData)) {
        return {
          success: false,
          message: errData.join(', '),
        };
      }

      return {
        success: false,
        message: error.response?.data?.message || 'Upload failed.',
      };
    }

    return {
      success: false,
      message: 'An unknown error occurred.',
    };
  }
};

export const getPatientsByOffice = (officeId: number) => {
  //replace {officeId} in the URL with the actual officeId
  const url = API_URL.PATIENTS_BY_PROVIDER.replace('{officeId}', officeId.toString());
  // Use the API interceptor to get the patients by office ID
  return apiInterceptor.get(url).then((response: any) => {
    return response;
  });
};

export const getPatientsByOfficeId = createAsyncThunk(
  'GET_GROUP_DETAILS',
  async (id: number, { rejectWithValue }: any) => {
    try {
      const response = await getPatientsByOffice(id);
      return response;
    } catch (err: any) {
      const e = err as Error;
      const status = e?.data?.errorCode;
      const message = handleMessage(status);
      const error = {
        err: err.data,
        message,
        show: false,
      };
      return rejectWithValue(error);
    }
  }
);
